
<a [FCRouterLink]="content.internalRoute ?? content.externalUrl">
    <div class="fc-header">{{content.heading}}</div>
    <div class="fc-icon">
        <img  [src]="content.iconSrc" [alt]="content.heading" />
    </div>
    <div class="fc-action" >
        <div class="fc-action-btn" [innerText]="content.internalRouteText"></div>
    </div>
</a>